import { useShallow } from 'zustand/shallow';

import { HcoSection } from '@/pages/MyDCRsPage/ViewDCRModal/_hooks/useHcoFieldNames';
import { HcpSection } from '@/pages/MyDCRsPage/ViewDCRModal/_hooks/useHcpFieldNames';

import { useDcrStore } from './dcrStore';

export const useDcrs = () =>
	useDcrStore(
		useShallow(state => ({
			dcrs: state.dcrs,
			rowCount: state.rowCount
		}))
	);

export const useDcrFormSearchTerm = () =>
	useDcrStore(({ dcrFormSearchTerm }) => dcrFormSearchTerm);

export const useDcrFormFilteredFields = (section: HcoSection | HcpSection) =>
	useDcrStore(
		useShallow(
			({ dcrFormFilteredFields }) => dcrFormFilteredFields[section] ?? []
		)
	);

export const useSetDcrs = () =>
	useDcrStore(useShallow(({ setDcrs }) => setDcrs));

export const useSetDcrFormSearchTerm = () =>
	useDcrStore(useShallow(({ setDcrFormSearchTerm }) => setDcrFormSearchTerm));

export const useSetDcrFormFilteredFields = () =>
	useDcrStore(
		useShallow(({ setDcrFormFilteredFields }) => setDcrFormFilteredFields)
	);
